/**
 * Shared Swym wishlist helpers for swym-wishlist.js, swym-wishlist-btn.js, swym-cart-saved.js.
 * Must load before those assets (defer order in Liquid).
 */
(function (global) {
  'use strict';

  if (global.SwymWishlistCore) return;

  var WISHLIST_LID_STORAGE_KEY = 'swym_wishlist_lid';

  function invokeSwymDualCallback(fn, ctx, onSuccessPayload, onError) {
    var err = typeof onError === 'function' ? onError : function () {};
    try {
      fn.call(ctx, onSuccessPayload, err);
      return true;
    } catch (e1) {
      try {
        fn.call(ctx, {
          callbackFn: onSuccessPayload,
          errorFn: err,
        });
        return true;
      } catch (e2) {
        try {
          fn.call(ctx, function (data) {
            onSuccessPayload(data);
          });
          return true;
        } catch (e3) {
          return false;
        }
      }
    }
  }

  function extractArrayFromLegacyResponse(data) {
    if (data == null) return [];
    if (Array.isArray(data)) return data;
    if (typeof data === 'object') {
      if (Array.isArray(data.items)) return data.items;
      if (Array.isArray(data.products)) return data.products;
      if (Array.isArray(data.data)) return data.data;
    }
    return [];
  }

  function isSaveForLaterList(l) {
    var t = l && l.lty;
    if (t == null || t === '') return false;
    if (t === '_saveForLater') return true;
    var lower = String(t).toLowerCase();
    if (lower.replace(/_/g, '') === 'saveforlater') return true;
    return lower.indexOf('save') !== -1 && lower.indexOf('later') !== -1;
  }

  function normalizeFetchListsPayload(raw) {
    if (!raw) return [];
    if (Array.isArray(raw)) return raw;
    if (Array.isArray(raw.data)) return raw.data;
    if (Array.isArray(raw.lists)) return raw.lists;
    return [];
  }

  function extractListItems(response) {
    if (!response) return [];
    if (Array.isArray(response.items)) return response.items;
    if (response.data && Array.isArray(response.data.items)) {
      return response.data.items;
    }
    return [];
  }

  function dedupeWishlistRowsKeepLast(rows) {
    var seen = Object.create(null);
    var out = [];
    var i;
    for (i = rows.length - 1; i >= 0; i--) {
      var it = rows[i];
      if (!it || it.epi == null) continue;
      var k = String(it.epi);
      if (seen[k]) continue;
      seen[k] = true;
      out.push(it);
    }
    out.reverse();
    return out;
  }

  function invokeFetchWishlist(swat, onSuccess, onError) {
    if (!swat || typeof swat.fetchWishlist !== 'function') return false;
    var err = typeof onError === 'function' ? onError : function () {};
    return invokeSwymDualCallback(
      swat.fetchWishlist,
      swat,
      function (data) {
        onSuccess(extractArrayFromLegacyResponse(data));
      },
      err,
    );
  }

  function wishlistEpiMatchesRow(item, data) {
    if (!item || item.epi == null || !data) return false;
    var ie = String(item.epi);
    if (data.epiStr != null && data.epiStr !== '' && ie === String(data.epiStr)) {
      return true;
    }
    if (data.epi != null && ie === String(data.epi)) return true;
    return false;
  }

  function lidForRemoveFromRows(items, data) {
    if (!items || !items.length) return null;
    var i;
    for (i = 0; i < items.length; i++) {
      if (wishlistEpiMatchesRow(items[i], data)) {
        return items[i].lid || null;
      }
    }
    return items[0].lid || null;
  }

  function epiForSwymApi(data) {
    if (typeof data.epi === 'number' && !isNaN(data.epi)) return data.epi;
    if (data.epiStr) {
      var n = parseInt(data.epiStr, 10);
      if (!isNaN(n)) return n;
    }
    return data.epi;
  }

  function productsJsonUrl(handle) {
    var root =
      typeof global.Shopify !== 'undefined' &&
      global.Shopify.routes &&
      global.Shopify.routes.root
        ? global.Shopify.routes.root
        : '/';
    if (root.slice(-1) !== '/') root += '/';
    return root + 'products/' + encodeURIComponent(handle) + '?view=wishlist-data';
  }

  function absoluteProductUrl(du) {
    if (!du) return '';
    if (/^https?:\/\//i.test(du)) return du;
    var origin = typeof global.location !== 'undefined' ? global.location.origin : '';
    if (du.charAt(0) === '/') return origin + du;
    return origin + '/' + du;
  }

  function pickWishlistList(lists) {
    if (!lists || lists.length === 0) return null;

    var nonSfl = lists.filter(function (l) {
      return !isSaveForLaterList(l);
    });
    if (nonSfl.length > 0) return nonSfl[0];

    var wl = lists.find(function (l) {
      return (l.lty || '').toLowerCase() === 'wl';
    });
    if (wl) return wl;

    return lists[0];
  }

  function rememberWishlistLid(lid) {
    if (lid == null || lid === '') return;
    try {
      global.sessionStorage.setItem(WISHLIST_LID_STORAGE_KEY, String(lid));
    } catch (e) {
      /* private mode / quota */
    }
  }

  function readStoredWishlistLid() {
    try {
      return global.sessionStorage.getItem(WISHLIST_LID_STORAGE_KEY) || null;
    } catch (e) {
      return null;
    }
  }

  function removeVariantFromSwym(swat, data, onSuccess, onError) {
    var errFn = typeof onError === 'function' ? onError : function () {};
    var okFn = typeof onSuccess === 'function' ? onSuccess : function () {};

    if (!swat || typeof swat.deleteFromList !== 'function') {
      errFn();
      return;
    }

    var product = {
      epi: epiForSwymApi(data),
      empi: data.empi,
      du: data.du,
    };

    function doDelete(lid) {
      if (!lid) {
        errFn();
        return;
      }
      swat.deleteFromList(
        lid,
        product,
        function () {
          okFn();
        },
        function () {
          errFn();
        },
      );
    }

    function fallbackLegacyLid() {
      if (
        !invokeFetchWishlist(
          swat,
          function (items) {
            doDelete(lidForRemoveFromRows(items, data));
          },
          errFn,
        )
      ) {
        errFn();
      }
    }

    if (typeof swat.fetchLists !== 'function') {
      fallbackLegacyLid();
      return;
    }

    swat.fetchLists({
      callbackFn: function (rawLists) {
        var lists = normalizeFetchListsPayload(rawLists);
        var withLid = lists.filter(function (l) {
          return l && l.lid;
        });
        if (!withLid.length) {
          fallbackLegacyLid();
          return;
        }

        function tryList(i) {
          if (i >= withLid.length) {
            fallbackLegacyLid();
            return;
          }
          var meta = withLid[i];
          swat.fetchListDetails(
            { lid: meta.lid },
            function (response) {
              var items = extractListItems(response);
              var has = items.some(function (it) {
                return wishlistEpiMatchesRow(it, data);
              });
              if (has) {
                doDelete(meta.lid);
              } else {
                tryList(i + 1);
              }
            },
            function () {
              tryList(i + 1);
            },
          );
        }

        tryList(0);
      },
      errorFn: function () {
        fallbackLegacyLid();
      },
    });
  }

  global.SwymWishlistCore = {
    WISHLIST_LID_STORAGE_KEY: WISHLIST_LID_STORAGE_KEY,
    invokeSwymDualCallback: invokeSwymDualCallback,
    extractArrayFromLegacyResponse: extractArrayFromLegacyResponse,
    isSaveForLaterList: isSaveForLaterList,
    normalizeFetchListsPayload: normalizeFetchListsPayload,
    extractListItems: extractListItems,
    dedupeWishlistRowsKeepLast: dedupeWishlistRowsKeepLast,
    invokeFetchWishlist: invokeFetchWishlist,
    wishlistEpiMatchesRow: wishlistEpiMatchesRow,
    lidForRemoveFromRows: lidForRemoveFromRows,
    epiForSwymApi: epiForSwymApi,
    productsJsonUrl: productsJsonUrl,
    absoluteProductUrl: absoluteProductUrl,
    pickWishlistList: pickWishlistList,
    rememberWishlistLid: rememberWishlistLid,
    readStoredWishlistLid: readStoredWishlistLid,
    removeVariantFromSwym: removeVariantFromSwym,
  };
})(typeof window !== 'undefined' ? window : this);
